import { useCallback } from 'react';

export const usePrefetch = () => {
  return useCallback((url: string, eventType: 'mouseenter' | 'touchstart') => {
    const prefetchLink = document.createElement('a');
    prefetchLink.href = url;
    prefetchLink.setAttribute('data-turbo-prefetch', 'true');
    prefetchLink.style.display = 'none';
    document.body.appendChild(prefetchLink);

    prefetchLink.dispatchEvent(new Event(eventType));
  }, []);
};
